export const navigation = [
  { text: 'Home', href: '/' },
  { text: 'Services', href: '/services' },
  { text: 'About Us', href: '/about' },
  { text: 'Contact Us', href: '/contact' },
];

export const contact = {
  phone: '(520) 975-0411',
  phoneHref: 'tel:5209750411',
  email: 'customerservice@gaasanalytical.com',
  emailHref: 'mailto:customerservice@gaasanalytical.com',
  address: {
    street: '245 S. Plumer Ave., Suite #5',
    city: 'Tucson, AZ 85719-6346',
  },
  social: {
    linkedin: 'https://www.linkedin.com/company/gaas-analytical',
    twitter: 'https://twitter.com/@gaasanalytical',
  },
};

export const hero = {
  headline: 'Reliable Analysis, Accurate Results',
  subheadline:
    'GAAS is an independent contract testing laboratory specializing in natural products, dietary supplements, and hemp/cannabis.',
};

export const servicesPreview = [
  {
    title: 'Quality Control',
    description:
      'GAAS provides analytical services for quality control of both raw materials and finished products. We specialize in botanicals and dietary supplements, although we also offer analysis for many common compounds.',
    icon: 'service-icon1.png',
  },
  {
    title: 'Method Development',
    description:
      'For novel or complex analyses, GAAS offers both method development and consulting services. GAAS is confident in its ability to develop novel methods for compounds which have no existing method developed.',
    icon: 'service-icon2.png',
  },
  {
    title: 'Consulting and Training',
    description:
      'For more specialized needs GAAS offers consulting services, including in-house analysis, expert testimony, and training for a range of analytical techniques and machines.',
    icon: 'service-icon3.png',
  },
];

export const valuePropositions = [
  {
    title: 'Make Compliance Easy',
    description:
      'GAAS makes compliance with FDA regulations easy. Our comprehensive reports go above and beyond industry standards and FDA requirements to include:',
    bullets: [
      'A detailed description of the analytical method and associated literature.',
      'A 5 point calibration curve.',
      'Raw chromatograms of the samples and standards.',
      'Statistical analysis for each measurement.',
    ],
  },
  {
    title: 'Personalized Attention',
    description:
      "We know your time is valuable, which is why GAAS provide a standard 7-day turnaround time for analyses — as well as rush processing when required. Moreover, GAAS prides itself in providing personalized support for your unique analytical needs. Drop us a line with any question you have and Aniko will get back to you within 24-48 hours.",
  },
  {
    title: 'Experience you can Trust',
    description:
      "We take your trust seriously. Dr. Sólyom has 30+ years of experience in analytical chemistry. She has participated in multiple AOAC collaborative studies, is a member of the Stakeholder Panel on Dietary Supplements (SPDS), and is an active member of multiple AOAC working groups. She serves on the Advisory Board of the NIST/NIH Dietary Supplement Laboratory Quality Assurance Program (DSQAP), and was recognized by AOAC's Cannabis Analytical Science Program as the expert review panelist of the year.",
  },
  {
    title: 'Pride in Excellence',
    description:
      "Quality assurance is as important to us as it is to you. GAAS is committed to providing detailed reports explaining not only the results, but also the methods used in analysis. Perhaps more importantly, GAAS itself voluntarily audits its own measurements on NIST evaluations to ensure that we are providing accurate results. It's no surprise that these audits show 95+% of our measurements fall within consensus range.",
  },
];

export const testimonials = [
  {
    company: 'NutraMedix',
    quote:
      'GAAS Analytical is among the absolute best in the trade! Their expertise in the lab and level of customer service is hard to beat. Extremely thorough and easy to read reports and assays. Highly recommended.',
    author: 'Jeff Gordley',
  },
  {
    company: 'Kalil Bottling Co.',
    quote:
      '[Aniko] has been a great help to me; Dr. Aniko has an excellent knowledge of LC and also providing technical expertise and solutions… I would highly recommend her services to anyone who has need of such services.',
    author: 'Hossain Monazzami',
  },
  {
    company: 'Extracts & Ingredients ltd.',
    quote:
      "We have utilized Dr. Sólyom's expertise for analytical projects, but also to provide consultation on various aspects of botanical extracts and methods. Her experience and depth of knowledge in this realm of natural materials is unexcelled, and has been very helpful in growing our business.",
    author: 'David Fondots',
  },
  {
    company: 'Wellome Sciences',
    quote:
      'After 4 years of contracting with GAAS Corporation, we consider them to be a model laboratory in the natural product and dietary supplement industry. … Integrally quality-driven, they are backed by equally superior customer service. … [GAAS] remains our "go-to" contract analytical laboratory.',
    author: 'Bailey Davis',
  },
];

export const certifications = [
  {
    title: 'cGMP Analysis',
    image: 'certification-logo1.jpg',
  },
  {
    title: 'Controlled Substances License',
    image: 'certification-logo2.jpg',
  },
  {
    title: 'NIST established Dietary Supplement Laboratory Quality Assurance Program',
    image: 'certification-logo3.jpg',
  },
];

export const services = {
  tabs: [
    'Analytical Testing Services',
    'Method Development and Validation',
    'Training & Consulting',
    'Expert Testimony',
  ],
  content: [
    {
      title: 'Analytical Testing Services',
      image: 'analytical-testing-ph1.jpg',
      intro:
        'GAAS Analytical is an independent contract testing laboratory for natural products, botanical drugs, phytochemicals, and dietary supplements. We test raw materials, intermediates and finished products according to cGMP regulations for identity and purity. Where they exist, we use regulatory and widely accepted industry methods (USP, AOAC, INA). When these methods do not yet exist, GAAS has a track record of developing new in-house methods for novel and difficult analyses. Many of these have since been accepted by as official USP standards. Our laboratory is DEA registered and cGMP compliant, offering reliable and accurate results, timely turnaround times, and unsurpassed responsiveness.',
      sections: [
        {
          title: 'Raw Materials',
          description:
            'The raw materials are the most important part of a retail product. Moreover, testing your raw materials is required under the dietary supplement cGMP regulation. We offer a full array of raw material testing that meet GMP, USP and FDA guidelines.',
        },
        {
          title: 'Finished Products',
          description:
            "Every sample is unique, and GAAS specializes in adapting. We offer analytical testing for all forms of natural products/dietary supplements, including tablets, capsules, softgels, powders, tinctures, oils, extracts and beadlets. The journey doesn't stop at analysis: we work with you to determine the underlying cause of any unexpected results.",
        },
        {
          title: 'Stability Testing',
          description:
            'GAAS Analytical offers stability protocols for your products according to the ICH Guidelines. GAAS can provide you the accelerated 3 month data for immediate market release and then follow with the 2-year room temperature stability data to defend your expiration date claim.',
        },
      ],
    },
    {
      title: 'Method Development and Validation',
      image: 'method-development-ph1.jpg',
      intro:
        "Backed by Dr. Sólyom's 30 years of research experience, GAAS specializes in developing new analytical methods for difficult-to-test products. Our validation protocols follow industry standards such as the ICH, USP, AOAC or the FDA's Guidance on Bio-analytical Methods Validation as required. We can work closely with you to customize our protocols to accommodate our client's individual needs and expectations and develop methods that are cost effective and produce timely results.",
    },
    {
      title: 'Training & Consulting',
      image: 'training-consulting-ph1.jpg',
      intro:
        'In addition to our in-house testing, GAAS provides high quality training and consulting on a variety of topics. GAAS can help quickly integrate instruments and software into your laboratory setup, decrease support costs, ensure employee development and achieve operational excellence and growth. We provide real-world case studies and one-on-one interaction. After attending a training session, attendees will be able to immediately implement practices and put the information learned into action.',
      additionalInfo:
        'Aniko has particular expertise on Agilent HPLC systems (e.g., Agilent 1100, 1200, and 1000RR), the Agilent 6400 Triple Quadropole, and the Agilent 6220 series Accurate Mass TOF and MSD trap. In addition, she is an expert in the associated OpenLab, ChemStation and MassHunter software suites.',
    },
    {
      title: 'Expert Testimony',
      image: 'expert-testimony-ph1.jpg',
      intro:
        'GAAS Analytical can offer true end-to-end analytical services to both protect against litigation as well as support companies during litigation.',
      supportedServices: [
        'Expert witness for analytical or quality issues.',
        'False advertising claims related to product content.',
        'Raw material disputes.',
        'Contract manufacturing disputes.',
        'Mediation where analytical data is in question.',
      ],
    },
  ],
};

export const about = {
  intro: [
    "GAAS Analytical was founded in 2008 by Dr. Anikó M. Sólyom to capitalize on her decades of experience at the University of Arizona researching botanical products. GAAS Analytical is an independent contract testing laboratory of natural products, botanical drugs, phytochemicals and dietary supplements, including raw materials, intermediates and finished products. We provide high quality analytical services, including routine testing, analytical method development & validation and contract research & development, to medium and small businesses and educational institutions.",
    "Over the past decade, GAAS has grown into a well-respected boutique laboratory, with a customer base that's grown to trust our analyses. We hope we can earn your trust too.",
  ],
  leadership: [
    {
      name: 'Anikó M. Sólyom, Ph.D.',
      role: 'The CEO and founder of GAAS',
      image: 'Aniko-ph2.jpg',
      bio: [
        'Anikó has more than 30 years of comprehensive experience in analytical method development and validation, using a wide variety of analytical techniques. Her expertise is in development and validation of analytical methods with particular emphasis on HPLC, LC-MS applications and bioactivity guided preparative separation of complex mixtures and analysis of biological samples and dietary supplements that she gained working on drug development and contract analysis both in academia and industry.',
        'In addition to HPLC technique she has significant experience with atomic absorption spectroscopy, inductively coupled plasma emission spectroscopy, photoacoustic spectroscopy, UV-Vis spectroscopy, elemental analysis, mass spectrometry, gas chromatography, GC-MS, LC-MS and NMR. She also has experience conducting absorption, distribution and elimination studies on animals.',
        'Before founding GAAS Corporation, Anikó served as director of the Analytical Core at an NIH funded Botanical Center (Arizona Center for Phytomedicine Research). The Facility focused on quantitation and identification of natural products and dietary supplements, particularly anti-inflammatory compounds from turmeric, ginger and boswellia. She developed methods to analyze these compounds from the plant materials, extracts, commercially available dietary supplements and from different biological matrices.',
        'Prior to GAAS, she served as the Project Manager at the University of Arizona for the "Studies of Chemical Disposition in Mammals" government contract (NO1-ES-45529, NIH/NIEHS), a multi-million dollar project. She also worked for Oncothyreon/ProlX Pharmaceuticals, a company specializing in cancer drug development, as the Manager of Analytical Services. Her duties included developing and validating new assay methods according to cGLP regulations, to quantify novel cancer drugs in plasma and urine using QQQ LC/MS technique; identifying metabolites of new cancer drugs in plasma and urine using TOF LC/MS technique and calculating pharmacokinetic parameters.',
        "Anikó is an active member of AOAC International; she joined the organization in 2002. Currently she is member of AOAC's Stakeholder Panel on Dietary Supplements responsible for developing, approving, and implementing standards for high priority dietary ingredients. She has participated in multiple AOAC organized collaborative studies (glucosamine, ginkgo, saw palmetto) in order to validate analytical methods to be used by the dietary supplement industry. She was Horwitz advisor of AOAC until the restructuring the Official Methods of Analysis (OMA) process in January 2008, when the role of method advisors and Horwitz advisors was retired. As a former Horwitz advisor she is familiar with the AOAC Official Methods (OMA) program. For 5 years she has been serving as member of the Presidential Task Force on Dietary Supplements of AOAC, and also served as member of Expert Review Panels of AOAC.",
      ],
    },
    {
      name: 'George Z. Angeli, Ph.D.',
      role: 'President of GAAS',
      image: 'George-ph.jpg',
      bio: [
        'Anikó is joined by George Angeli, co-founder and president of GAAS. George is responsible for operational management at GAAS. George has extensive experience in engineering management, systems engineering and project management for projects ranging from small to very large. As Systems Engineering Manager, he is the chief technical leader of a $650M federally funded project, the Large Synoptic Survey Telescope. He was formerly Head of Systems Engineering of the Thirty Meter Telescope Observatory, an international partnership between the USA, Canada, Japan, India, and China to build an Extremely Large Optical Telescope (ELT). Before that he was the project manager of a team developing real time, phase shifting interferometers at WYKO.',
      ],
    },
  ],
  laboratory: {
    intro:
      "GAAS serves clients throughout the United States and Canada from our facility in Tucson, Arizona, near the University of Arizona. GAAS' facility consists of 200 square feet of office, 200 square feet for analytical instrumentation and 800 square feet sample preparation and storage space. The facility is protected with a continuously monitored security system and equipped with features required for the health & safety of our employees. The laboratory was designed and constructed for the efficient production of high quality analytical services.",
    equipment:
      'The laboratory is equipped with an Agilent 1200 series Rapid Resolution HPLC system, including SL binary pump, vacuum degasser, thermostatted autosampler, thermostatted column compartment and diode array detector. The laboratory is additionally equipped with standard laboratory equipment: UV-vis spectrophotometer, micro- and analytical balances, Buchi R-200 rotary evaporator, benchtop concentrator, solid phase extraction (SPE) apparatus, water purification system, furnace oven, temperature controlled water bath, centrifuges, vacuum oven, ultra-low temperature freezer, and common laboratory equipment (hot plates, oven, stirrers, shakers, ultrasonic cleaner, mini centrifuge, pH meter, vacuum pumps, refrigerator) to perform the preparation and analysis of samples.',
    additionalServices:
      'In addition to our own facility, GAAS has access on a fee basis to the services of the University of Arizona.',
  },
};

export const quoteEmailTemplate = (serviceType: string) => {
  const subject = encodeURIComponent(`Quote Request - ${serviceType}`);
  const body = encodeURIComponent(`Dear Dr. Sólyom,

I am writing to request a quote for your analytical services.

Sample/Material to be analyzed:
[Please describe what you need analyzed]

Timeline/Urgency:
[Please indicate your time constraints or desired turnaround]

Additional details:
[Any other relevant information]

Thank you,
[Your name]`);
  return `mailto:customerservice@gaasanalytical.com?subject=${subject}&body=${body}`;
};
